import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { jsonHeaders } from '#lib/helpers/fetch.js';

async function fetchCurrencies(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/currencies`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return await response.json();
}

export function useCurrencies() {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['currencies'],
        queryFn: fetchCurrencies,
        staleTime: Infinity,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0
    });

    return {
        currencies: data?.results,
        ...queryProps
    };
}
